import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { ToastStatusEnum } from '@ui-kit/app-toast/toast-status.enum';
import { ToasterService } from '@ui-kit/app-toast/toaster.service';
import { concatMap, Observable } from 'rxjs';
import { catchError, filter, take, tap } from 'rxjs/operators';

import { AuthService } from '@features/auth/auth.service';
import { MittanbudService } from '@features/scheduler/unscheduled-projects/mittanbud-banner/mittanbud.service';
// eslint-disable-next-line max-len
import { MittanbudSuccessContact } from '@features/scheduler/unscheduled-projects/mittanbud-banner/mittanbud-success-contact/mittanbud-success-contact';
import { ButtonsModule } from '@ui-kit/buttons/buttons.module';
import { LoaderModule } from '@ui-kit/loader/loader.module';
import { handleError } from '@ui-kit/utility/handleHttpErrorResponse';
import { PushModule } from '@rx-angular/template/push';

@Component({
  selector: 'mittanbud-pop-up',
  standalone: true,
  templateUrl: './mittanbud-pop-up.component.html',
  styleUrl: './mittanbud-pop-up.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonsModule, LoaderModule, NgOptimizedImage, TranslateUiModule, PushModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'mittanbud-modal'
  }
})
export class MittanbudPopUpComponent {
  private _dialogRef: MatDialogRef<MittanbudPopUpComponent> = inject(MatDialogRef);
  private _matDialog: MatDialog = inject(MatDialog);
  private _mittanbudService: MittanbudService = inject(MittanbudService);
  private _toaster: ToasterService = inject(ToasterService);

  jobStats = [
    {
      icon: 'icon-Save_ico text-s3-go-green text-12',
      key: marker('211 000 jobs last year')
    },
    {
      icon: 'icon-Save_ico text-s3-go-green text-12',
      key: marker('4 responses on average pr. job')
    },
    {
      icon: 'icon-Save_ico text-s3-go-green text-12',
      key: marker('32 000 kr average job deals')
    }
  ];

  mainTitle: string = marker('Get 50 % off on 10 Mittanbud tickets and grow your client list');
  subTitle: string = marker('Thousands of new jobs every week');
  getContacted: string = marker('Get Contacted');
  get mittanbud(): MittanbudService {
    return this._mittanbudService;
  }

  close(): void {
    this._dialogRef.close();
  }

  initSuccess(): void {
    this._matDialog.open(MittanbudSuccessContact, {
      width: '356px',
      height: '300px',
      panelClass: 'mittanbud-success'
    });
  }

  sendAccountRequest(): Observable<any> {
    this.mittanbud.closedByAccount.set(true);

    return this.mittanbud.closeByAccount({
      value: JSON.stringify({
        mittanbud_request: {
          value: this.mittanbud.closedByAccount()
        }
      })
    });
  }

  getContact(): void {
    this.mittanbud
      // eslint-disable-next-line @typescript-eslint/naming-convention
      .initMittanbud()
      .pipe(
        filter(({ success }) => !!success),
        tap(() => this.close()),
        tap(() => this.initSuccess()),
        concatMap(() => this.sendAccountRequest()),
        catchError(({ error }) => {
          return handleError(error, this._toaster);
        }),
      )
      .subscribe();
  }
}
